import { render, staticRenderFns } from "./select-account.vue?vue&type=template&id=3b400002&scoped=true"
import script from "./select-account.vue?vue&type=script&lang=js"
export * from "./select-account.vue?vue&type=script&lang=js"
import style0 from "./select-account.vue?vue&type=style&index=0&id=3b400002&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b400002",
  null
  
)

export default component.exports